/*
 * Starile pe care le are fiecare ecran: se incarca, a cazut, e gol.
 *
 * Sunt componente comune si nu bucati copiate in ecrane, pentru ca cerinta e ca
 * niciun ecran sa nu ramana mut cand api-ul cade. Un ecran care nu spune nimic
 * arata identic cu unul stricat, iar omul din banca suna la service desk ca
 * "nu merge nimic" - fara cod de eroare, fara nimic de cautat in loguri.
 * De-asta starea de eroare arata mereu trei lucruri: ce s-a intamplat pe
 * intelesul omului, codul tehnic, si un buton de reincercare.
 */

import type { ReactNode } from 'react';
import type { ApiError } from '../api/errors';
import { t } from '../lib/i18n';

export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="state" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <p className="state__text">{label}</p>
    </div>
  );
}

export function ErrorState({
  error,
  onRetry,
  title = t('This screen could not be loaded'),
}: {
  error: ApiError;
  onRetry?: () => void;
  title?: string;
}) {
  return (
    <div className="state state--error" role="alert">
      <h2 className="state__title">{title}</h2>
      <p className="state__text">{error.message}</p>
      {onRetry ? (
        <p className="state__actions">
          <button type="button" className="btn" onClick={onRetry}>{t('Try again')}</button>
        </p>
      ) : null}
      <p className="state__code">
        <span className="micro-label">{t('Error code')}</span>
        <code>{error.code}</code>
      </p>
    </div>
  );
}

export function EmptyState({
  title,
  text,
  action,
}: {
  title: string;
  text: string;
  action?: ReactNode;
}) {
  return (
    <div className="state">
      <h2 className="state__title">{title}</h2>
      <p className="state__text">{text}</p>
      {action ? <p className="state__actions">{action}</p> : null}
    </div>
  );
}

/** Eroare care apartine unui formular sau unei sectiuni, nu intregului ecran. */
export function InlineAlert({ children }: { children: ReactNode }) {
  return (
    <div className="alert" role="alert">
      {children}
    </div>
  );
}
